  import React, { useEffect, useState } from "react";
  import OvertimeForShiftPopup from "../OvertimeForShiftPopup";
  import AbsenceForShiftPopup from "../AbsenceForShiftPopup";
  import BreakForShiftPopup from "../BreakForShiftPopup";
  import { MultipleDatesInShiftPopup } from "../MultipleDatesInShiftPopup";

  import { addEmployeesToProjectFromShift } from "../../utils/addEmployeesToProject";
  

  const ShiftEditorModal = ({
    isOpen,
    onClose,

    isEditing,

    shiftFormData,
    setShiftFormData,

    handleShiftSubmit,
    handleShiftDelete,

    buttonLoading,
    deleteLoading,

    allEmployees,
    allAbsenceRules,
    allOvertimeRules,

    canEditShifts,

    selectedEmployeeForOvertime,
    setSelectedEmployeeForOvertime,

    selectedEmployeeForAbsence,
    setSelectedEmployeeForAbsence,

    selectedEmployeeForBreak,
    setSelectedEmployeeForBreak,

    selectedOvertimeIndex,
    setSelectedOvertimeIndex,

    selectedAbsenceIndex,
    setSelectedAbsenceIndex,

    selectedBreakIndex,
    setSelectedBreakIndex,

    showOvertimeForShiftPopup,
    setShowOverTimeForShiftPopup,

    showAbsenceForShiftPopup,
    setShowAbsenceForShiftPopup,

    showBreakPopup,
    setShowBreakPopup,

    showMultipleDatesShiftPopup,
    setShowMultipleDatesShiftPopup,

    multipleDates,
    setMultipleDates,

    selectedMultipleStartDate,
    setSelectedMultipleStartDate,

    selectedMultipleEndDate,
    setSelectedMultipleEndDate,

    selectedMultipleMode,
    setSelectedMultipleMode,

    selectedMultipleWeekdays,
    setSelectedMultipleWeekdays,

    selectedMultipleCustomDates,
    setSelectedMultipleCustomDates,

    useMultipleDates,
    setUseMultipleDates,

    employeesNotInProject,
    setEmployeesNotInProject,

    overlappingShiftWarningText,


    company,
    user,

    setToastType,
    setToastMessage,

    setAllProjects,
    allProjects,

    setProjects,
    projects,

    allShiftsToday,
    currentShiftId, 
  }) => {

    const [expandedEmployees, setExpandedEmployees] = useState({});
    const [showCloseWarning, setShowCloseWarning] = useState(false);

    const selectedCount = shiftFormData.employees.filter(e => e.employeeId).length;
    const totalSlots = shiftFormData.employees.length;
    const hasOpenSlots = selectedCount < totalSlots;

    const [initialShiftData, setInitialShiftData] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setInitialShiftData(JSON.stringify(shiftFormData));
        }
    }, [isOpen]);


    // 🚨 Auto-disable applications if required fields become invalid
    useEffect(() => {
        const missingRequired =
        !shiftFormData.project ||
        !shiftFormData.date ||
        !shiftFormData.startTime ||
        !shiftFormData.endTime;

        if (shiftFormData.allowApplications && missingRequired) {
        setShiftFormData(prev => ({
            ...prev,
            allowApplications: false
        }));
        }
    }, [
        shiftFormData.project,
        shiftFormData.date,
        shiftFormData.startTime,
        shiftFormData.endTime,
        shiftFormData.allowApplications
    ]);


    useEffect(() => {
        if (!hasOpenSlots && shiftFormData.allowApplications) {
        setShiftFormData(prev => ({ ...prev, allowApplications: false }));
        }
    }, [hasOpenSlots, shiftFormData.allowApplications]);



    if (!isOpen) return null;




    const addAnotherEmployee = () => {
        if (shiftFormData.employees.length < 50) {
        setShiftFormData({
            ...shiftFormData,
            employees: [...shiftFormData.employees, { employeeId: '', overtime: [], absences: [], breaks: [] }]
        });
        }
    };

    const removeLastEmployee = () => {
        if (shiftFormData.employees.length > 1) {
        setShiftFormData({
            ...shiftFormData,
            employees: shiftFormData.employees.slice(0, -1)
        });
        }
    };


    const handleCloseAttempt = () => {
        const hasChanges = initialShiftData && JSON.stringify(shiftFormData) !== initialShiftData;
        if (hasChanges) {
            setShowCloseWarning(true);
        } else {
            onClose();
        }
    };

    const confirmClose = () => {
        setShowCloseWarning(false);
        onClose();
    };

    const cancelClose = () => {
        setShowCloseWarning(false);
    };
        
  
    const handleAddEmployeesToProject = async () => {
        const employeesArr = employeesNotInProject

        const data = await addEmployeesToProjectFromShift({ employees: employeesArr, user, company, project: shiftFormData.project })

        if (data.status === "success") {
        setAllProjects(allProjects.map((p) =>
            p._id === data.project._id ? data.project : p
        ));
        setProjects(projects.map((p) =>
            p._id === data.project._id ? data.project : p
        ));

        setEmployeesNotInProject([])
        setToastType("success");
        setToastMessage("Användare tillagd i projektet!");
        }
        else {
        setToastType("error");
        setToastMessage(data.errorText);
        }
    }

    const handleAddOvertimeToEmployee = (employeeId, newOvertime) => {
        setShiftFormData((prev) => ({
        ...prev,
        employees: prev.employees.map((emp) =>
            emp.employeeId === employeeId
            ? {
                ...emp,
                overtime: [...emp.overtime, newOvertime],
            }
            : emp
        )
        }));
    };

    const handleRemoveOvertime = (employeeId, index) => {
        setShiftFormData((prev) => ({
        ...prev,
        employees: prev.employees.map((emp) =>
            emp.employeeId === employeeId
            ? {
                ...emp,
                overtime: emp.overtime.filter((_, i) => i !== index)
            }
            : emp
        )
        }));
    };

    const handleAddAbsenceToEmployee = (employeeId, absenceObj) => {
        setShiftFormData((prev) => ({
        ...prev,
        employees: prev.employees.map((emp) =>
            emp.employeeId === employeeId
            ? {
                ...emp,
                absences: [...(emp.absences || []), absenceObj]
            }
            : emp
        )
        }));
    };

    const handleRemoveAbsenceFromEmployee = (employeeId, index) => {
        setShiftFormData((prev) => ({
        ...prev,
        employees: prev.employees.map((emp) =>
            emp.employeeId === employeeId
            ? {
                ...emp,
                absences: emp.absences.filter((_, i) => i !== index)
            }
            : emp
        )
        }));
    };


    const handleRemoveBreak = (employeeId, index) => {
        setShiftFormData((prev) => ({
        ...prev,
        employees: prev.employees.map((emp) =>
            emp.employeeId === employeeId
            ? {
                ...emp,
                breaks: (emp.breaks || []).filter((_, i) => i !== index)
            }
            : emp
        )
        }));
    };


    const getRuleName = (ruleId) => {
        const rule = allOvertimeRules.find((r) => r._id === ruleId);
        return rule ? rule.name : "Okänd regel";
    };




    const getWholeShiftAbsenceInPopup = (shiftFormData, employee) => {
        if (!shiftFormData?.startTime || !shiftFormData?.endTime) return null;
        if (!employee?.absences?.length) return null;

        const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
        };

        const shiftStart = toMin(shiftFormData.startTime);
        const shiftEnd   = toMin(shiftFormData.endTime);

        for (const abs of employee.absences) {
        if (abs.appliesWholeShift) return abs;

        if (!abs.from || !abs.to) continue;

        const absStart = toMin(abs.from);
        const absEnd   = toMin(abs.to);

        if (absStart <= shiftStart && absEnd >= shiftEnd) {
            return abs;
        }
        }

        return null;
    };


    return (
        <div className="select-employee-popup-overlay" onClick={() => handleCloseAttempt()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div
            className="select-employee-popup"
            onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, paddingTop: 24, paddingLeft: 24, paddingRight: 24, paddingBottom: (overlappingShiftWarningText !== "" || (employeesNotInProject.length > 0 && shiftFormData.project)) ? 24 : 8, width: 'clamp(960px, 92vw, 1280px)', maxWidth: '92vw', minWidth: '720px', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 12px 32px rgba(0,0,0,0.18)', border: '1px solid #e5e7eb' }}
        >
            <h4 style={{ margin: '0 0 16px 0', fontSize: 20, fontWeight: 700, color: '#111827' }}>{isEditing ? "Redigera Pass" : "Skapa Pass"}</h4>
            <form onSubmit={handleShiftSubmit} className="shift-form">
            {/* Sektion för Anställda */}
            <div className="shift-section">
                <h5 className="shift-section-title" style={{ margin: '0 0 10px 0', fontSize: 14, letterSpacing: '.2px', textTransform: 'uppercase', color: '#6b7280' }}>Anställda</h5>

                {shiftFormData.employees.map((employeeObj, index) => {
                const isExpanded = expandedEmployees[employeeObj.employeeId] ?? false;
                const onlyOne = shiftFormData.employees.length === 1;

                const wholeShiftAbsence = getWholeShiftAbsenceInPopup(shiftFormData, employeeObj);
                const wholeShiftAbsent = !!wholeShiftAbsence;

                return (
                    <div key={index} style={{ marginBottom: '14px', padding: '12px', border: '1px solid #e5e7eb', borderRadius: 10, background: '#fafafa', fontSize: '13px' }}>
                    {/* EN rad: Ta bort • Input • Visa/Dölj */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', columnGap: '10px', alignItems: 'center', marginBottom: '8px' }}>
                        {/* Ta bort: alltid synlig, disabled om bara en */}
                        <button
                        type="button"
                        title={onlyOne ? 'Minst en anställd krävs' : 'Ta bort anställd'}
                        disabled={onlyOne}
                        onClick={!onlyOne ? () => {
                            const updated = shiftFormData.employees.filter((_, i) => i !== index);
                            setShiftFormData({ ...shiftFormData, employees: updated });
                        } : undefined}
                        aria-disabled={onlyOne}
                        style={{
                            width: 36,
                            height: 36,
                            background: onlyOne ? '#F3F4F6' : '#ef4444',
                            color: onlyOne ? '#9CA3AF' : '#fff',
                            border: `1px solid ${onlyOne ? '#E5E7EB' : '#ef4444'}`,
                            borderRadius: '8px',
                            cursor: onlyOne ? 'not-allowed' : 'pointer',
                            fontSize: '18px',
                            lineHeight: 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: '0 0 auto',
                            whiteSpace: 'nowrap',
                            opacity: onlyOne ? 0.75 : 1,
                            boxShadow: onlyOne ? 'none' : '0 1px 2px rgba(0,0,0,0.05)'
                        }}
                        >
                        −
                        </button>

                        {/* Input */}
                        <div style={{ minWidth: 0 }}>
                        <input
                            list={`employee-options-${index}`}
                            id={`employee-input-${index}`}
                            value={employeeObj.employeeName || allEmployees.find(emp => emp._id === employeeObj.employeeId)?.name || ""}
                            onChange={(e) => {
                            const inputValue = e.target.value;
                            const selectedEmployeeObj = allEmployees.find(emp => emp.name.toLowerCase() === inputValue.toLowerCase());
                            const updated = [...shiftFormData.employees];
                            updated[index] = { ...updated[index], employeeId: selectedEmployeeObj?._id || "", employeeName: selectedEmployeeObj ? "" : inputValue };
                            setShiftFormData({ ...shiftFormData, employees: updated });
                            }}
                            placeholder="Skriv eller välj anställd"
                            style={{
                            width: '100%',
                            height: 36,
                            padding: '6px 10px',
                            border: wholeShiftAbsent ? '1px solid #FDE68A' : '1px solid #cbd5e1',
                            borderRadius: '8px',
                            fontSize: '13px',
                            background: wholeShiftAbsent ? '#FEF9C3' : '#ffffff',
                            transition: 'background 0.15s ease, border 0.15s ease'
                            }}
                        />
                        <datalist id={`employee-options-${index}`}>{allEmployees.map((emp) => (<option key={emp._id} value={emp.name} />))}</datalist>
                        </div>

                        {/* Visa/Dölj */}
                        <button
                        type="button"
                        onClick={() => setExpandedEmployees(prev => ({ ...prev, [employeeObj.employeeId]: !isExpanded }))}
                        aria-expanded={isExpanded}
                        style={{
                            height: 36,
                            padding: '0 12px',
                            backgroundColor: isExpanded ? '#fef2f2' : '#f8fafc',
                            color: isExpanded ? '#b91c1c' : '#334155',
                            border: `1px solid ${isExpanded ? '#fecaca' : '#e2e8f0'}`,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: 600,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all .2s',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                            flex: '0 0 auto',
                            whiteSpace: 'nowrap'
                        }}
                        >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ transition: 'transform .2s', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }} aria-hidden="true"><path d="M19 9L12 16L5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        {isExpanded ? "Dölj" : "Visa"}
                        </button>
                    </div>

                    {isExpanded && (
                        <>
                        {/* Raster */}
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', gap: 10, flexWrap: 'wrap' }}>
                            <div style={{ fontWeight: 700, color: '#111827' }}>Raster:</div>
                            {canEditShifts && (<button type="button" onClick={() => { setSelectedEmployeeForBreak(employeeObj.employeeId); setShowBreakPopup(true); setSelectedBreakIndex(null); }} style={{ background: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '14px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}><span style={{ fontSize: '16px', lineHeight: 1 }}>+</span> Lägg till</button>)}
                            </div>
                            {(employeeObj.breaks || []).map((brk, i) => (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #eee', gap: 10, flexWrap: 'wrap' }}>
                                <span style={{ backgroundColor: '#F8FAFC', color: '#1F2937', padding: '4px 10px', borderRadius: 4, fontFamily: 'sans-serif', fontSize: '0.8125rem', fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 6, border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>{brk.from} – {brk.to}</span>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                {
                                    canEditShifts && (
                                    <>
                                        <button type="button" onClick={() => { setSelectedEmployeeForBreak(employeeObj.employeeId); setSelectedBreakIndex(i); setShowBreakPopup(true); }} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#4f46e5', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Redigera</button>
                                        <button type="button" onClick={() => handleRemoveBreak(employeeObj.employeeId, i)} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#e11d48', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Radera</button>                           
                                    </>
                                    )
                                }
                                </div>
                            </div>
                            ))}
                        </div>

                        {/* Övertid */}
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', gap: 10, flexWrap: 'wrap' }}>
                            <div style={{ fontWeight: 700, color: '#111827' }}>Övertid:</div>
                            {canEditShifts && (<button type="button" onClick={() => { setSelectedOvertimeIndex(null); setShowOverTimeForShiftPopup(true); setSelectedEmployeeForOvertime(employeeObj.employeeId); }} style={{ background: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '14px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}><span style={{ fontSize: '16px', lineHeight: 1 }}>+</span> Lägg till</button>)}
                            </div>
                            {(employeeObj.overtime || []).map((ot, i) => (
                            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #eee', gap: 10, flexWrap: 'wrap' }}>
                                <span style={{ backgroundColor: '#E0F2FE', color: '#075985', padding: '4px 10px', borderRadius: 4, fontFamily: 'sans-serif', fontSize: '0.8125rem', fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 6, border: '1px solid #BAE6FD', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
                                {getRuleName(ot.type) && (<strong style={{ fontSize: '0.75rem', marginRight: 6 }}>{getRuleName(ot.type)}</strong>)}
                                <span>{ot.from} – {ot.to}</span>
                                {ot.source === 'auto' && (<span style={{ fontSize: '0.75rem', opacity: 0.85, marginLeft: 6 }}>auto</span>)}
                                </span>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                {canEditShifts && (
                                    <>
                                    <button type="button" onClick={() => { setSelectedOvertimeIndex(i); setSelectedEmployeeForOvertime(employeeObj.employeeId); setShowOverTimeForShiftPopup(true); }} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#4f46e5', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Redigera</button>
                                    {!ot.source || ot.source !== "auto" ? (<button type="button" onClick={() => handleRemoveOvertime(employeeObj.employeeId, i)} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#e11d48', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Radera</button>) : null}
                                    </>
                                )}
                                </div>
                            </div>
                            ))}
                        </div>

                        {/* Frånvaro */}
                        <div style={{ marginBottom: '4px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', gap: 10, flexWrap: 'wrap' }}>
                            <div style={{ fontWeight: 700, color: '#111827' }}>Frånvaro:</div>
                            {
                                canEditShifts && (<button type="button" onClick={() => { setSelectedAbsenceIndex(null); setSelectedEmployeeForAbsence(employeeObj.employeeId); setShowAbsenceForShiftPopup(true); }} style={{ background: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '14px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}><span style={{ fontSize: '16px', lineHeight: 1 }}>+</span> Lägg till</button>)
                            }
                            </div>

                            {(employeeObj.absences || []).map((absence, idx) => {
                            const absenceName = allAbsenceRules.find(a => a._id === absence.absenceType)?.name || "Okänd frånvaro";
                            return (
                                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #eee', gap: 10, flexWrap: 'wrap' }}>
                                <span style={{ backgroundColor: '#FFF3CD', color: '#856404', padding: '4px 10px', borderRadius: 4, fontFamily: 'sans-serif', fontSize: '0.8125rem', fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 6, border: '1px solid #FFEEBA', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
                                    <strong style={{ fontWeight: 700 }}>{absenceName}</strong>
                                    {!absence.wholeShift && absence.from && absence.to && (<span style={{ fontWeight: 400, opacity: 0.8 }}>| {absence.from} – {absence.to}</span>)}
                                </span>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    {canEditShifts && (
                                    <>
                                        <button type="button" onClick={() => { setSelectedEmployeeForAbsence(employeeObj.employeeId); setSelectedAbsenceIndex(idx); setShowAbsenceForShiftPopup(true); }} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#4f46e5', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Redigera</button>
                                        <button type="button" onClick={() => handleRemoveAbsenceFromEmployee(employeeObj.employeeId, idx)} style={{ background: 'none', border: '1px solid transparent', borderRadius: 6, color: '#e11d48', cursor: 'pointer', fontSize: '12px', padding: '4px 8px' }}>Radera</button>                          
                                    </>
                                    )}

                                </div>
                                </div>
                            );
                            })}
                        </div>
                        </>
                    )}
                    </div>
                );
                })}

                {/* Lägg till anställd – under alla employees */}
                {(shiftFormData.employees.length < 50 && canEditShifts) && (
                <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'flex-start', paddingBottom: 20 }}>
                    <span onClick={addAnotherEmployee} style={{ cursor: 'pointer', fontSize: '0.8rem', fontWeight: 700, backgroundColor: '#ffffff', padding: '8px 12px', border: '1px solid #45a4e3', borderRadius: '8px', color: '#45a4e3', userSelect: 'none' }}>+ Lägg till anställd</span>
                </div>
                )}

                {/* Ansökningsbart pass */}
                {/* <div style={{ marginBottom: 14, borderTop: "white solid 10px", paddingTop: 10 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: hasOpenSlots ? "pointer" : "not-allowed" }}>
                    <div
                    onClick={() => {

                        console.log({ hasOpenSlots, shiftFormData });

                        if (!shiftFormData.project || !shiftFormData.date || !shiftFormData.startTime || !shiftFormData.endTime) {
                        alert("Projekt, datum, starttid och sluttid måste anges för att passet ska kunna vara öppet för ansökningar");
                        return;
                        }

                        if (!hasOpenSlots) return;

                        setShiftFormData({ ...shiftFormData, allowApplications: !shiftFormData.allowApplications });
                    }}

                    style={{
                        width: 42, height: 24, borderRadius: 20,
                        background: shiftFormData.allowApplications ? "#10b981" : "#e5e7eb",
                        position: "relative", transition: "0.2s",
                        opacity: hasOpenSlots ? 1 : 0.5
                    }}
                    >
                    <div style={{
                        position: "absolute", top: 2, left: shiftFormData.allowApplications ? 22 : 2,
                        width: 20, height: 20, borderRadius: "50%", background: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)", transition: "0.2s"
                    }}/>
                    </div>

                    <span style={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>
                    Öppet för ansökningar till lediga platser
                    </span>
                </label>

                {!hasOpenSlots && (
                    <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 4 }}>
                    Alla platser är fyllda
                    </div>
                )}
                </div> */}



                <div style={{ borderTop: "#fff 10px solid" }}>
                <h5 className="shift-section-title" style={{ margin: '14px 0 10px 0', fontSize: 14, letterSpacing: '.2px', textTransform: 'uppercase', color: '#6b7280' }}>Meddelande</h5>
                <textarea
                    value={shiftFormData.message || ""}
                    onChange={(e) => setShiftFormData({ ...shiftFormData, message: e.target.value })}
                    placeholder="Lägg till ett meddelande för detta pass..."
                    rows={3}
                    style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '10px',
                    fontSize: '14px',
                    background: '#fff',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    minHeight: 70,
                    height: 70,
                    maxHeight: 150
                    }}
                />
                </div>
            </div>

            {/* Sektion för Projekt + Tider */}
            <div className="shift-section">
                <h5 className="shift-section-title" style={{ margin: '14px 0 10px 0', fontSize: 14, letterSpacing: '.2px', textTransform: 'uppercase', color: '#6b7280' }}>Projekt</h5>
                <input
                list="project-options"
                id="project-input"
                value={shiftFormData.projectName || allProjects.find(p => p._id === shiftFormData.project)?.name || ""}
                onChange={(e) => {
                    const inputValue = e.target.value;
                    const selectedProjectObj = allProjects.find(p => p.name.toLowerCase() === inputValue.toLowerCase());
                    setShiftFormData({ ...shiftFormData, project: selectedProjectObj?._id || "", projectName: selectedProjectObj ? "" : inputValue });
                }}
                placeholder="Skriv eller välj projekt"
                className="shift-form-input"
                style={{ width: '100%', height: 38, padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '10px', fontSize: '14px', background: '#fff' }}
                />
                <datalist id="project-options">{allProjects.map((project) => (<option key={project._id} value={project.name} />))}</datalist>

                <h5 className="shift-section-title" style={{ margin: '20px 0 10px 0', fontSize: 14, letterSpacing: '.2px', textTransform: 'uppercase', color: '#6b7280' }}>Tider</h5>

                <div>
                {/* Datum */}
                {useMultipleDates && !isEditing ? (
                    <>
                    <div className="shift-row">
                        <label style={{ fontWeight: 600, fontSize: '14px', color: '#111827', display: 'block', marginBottom: 6 }}>Datum</label>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '14px', color: '#111827' }}>📅 {multipleDates.length === 1 ? multipleDates[0] : `${multipleDates.length} datum valda`}</span>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button onClick={(e) => { e.preventDefault(); setShowMultipleDatesShiftPopup(true); }} style={{ background: 'none', color: '#2563eb', border: '1px solid transparent', borderRadius: 6, fontSize: '13px', cursor: 'pointer', textDecoration: 'underline', padding: '4px 6px' }}>ändra</button>
                            <button onClick={(e) => { e.preventDefault(); setUseMultipleDates(false); setMultipleDates([]); }} style={{ background: 'none', color: '#6b7280', border: '1px solid transparent', borderRadius: 6, fontSize: '13px', cursor: 'pointer', textDecoration: 'underline', padding: '4px 6px' }}>byt till ett datum</button>
                        </div>
                        </div>

                        {multipleDates.length > 1 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                            {multipleDates.map((date) => (
                            <div key={date} style={{ padding: '4px 8px', backgroundColor: '#45a4e3', borderRadius: 6, fontSize: '13px', color: '#ffffff', border: '1px solid rgba(0,0,0,0.05)' }}>{date}</div>
                            ))}
                        </div>
                        )}
                    </div>
                    </>
                ) : (
                    <>
                    <div className="shift-row" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        <label htmlFor="date" style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>Datum</label>
                        <input
                        type="date"
                        value={shiftFormData.date ? new Date(shiftFormData.date).toISOString().split("T")[0] : ""}
                        onChange={(e) => setShiftFormData({ ...shiftFormData, date: e.target.value })}
                        required
                        className="shift-form-input"
                        style={{ width: '100%', height: 38, padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '10px', fontSize: '14px', background: '#fff' }}
                        />
                        {!isEditing && (
                        <button
                            onClick={(e) => {
                            e.preventDefault();
                            if (selectedMultipleEndDate === null && selectedMultipleStartDate === null) {
                                setSelectedMultipleEndDate(shiftFormData.date);
                                setSelectedMultipleStartDate(shiftFormData.date);
                            }
                            setUseMultipleDates(true);
                            setShowMultipleDatesShiftPopup(true);
                            }}
                            style={{ background: 'none', color: '#6b7280', border: '1px solid transparent', borderRadius: 6, fontSize: '13px', cursor: 'pointer', textDecoration: 'underline', marginTop: '2px', padding: '4px 6px', alignSelf: 'flex-start' }}
                        >
                            välj flera datum istället
                        </button>
                        )}
                    </div>
                    </>
                )}

                {/* Starttid */}
                <div className="shift-row" style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: 10 }}>
                    <label htmlFor="startTime" style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>Starttid</label>
                    <input
                    type="time"
                    value={shiftFormData.startTime}
                    onChange={(e) => setShiftFormData({ ...shiftFormData, startTime: e.target.value })}
                    className="shift-form-input"
                    style={{ width: '100%', height: 38, padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '10px', fontSize: '14px', background: '#fff' }}
                    />
                </div>

                {/* Sluttid */}
                <div className="shift-row" style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: 10 }}>
                    <label htmlFor="endTime" style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>Sluttid</label>
                    <input
                    type="time"
                    value={shiftFormData.endTime}
                    onChange={(e) => setShiftFormData({ ...shiftFormData, endTime: e.target.value })}
                    className="shift-form-input"
                    style={{ width: '100%', height: 38, padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '10px', fontSize: '14px', background: '#fff' }}
                    />
                </div>
                </div>
            </div>

            {/* Buttons */}
            <div className="shift-buttons" style={{ display: 'flex', gap: '10px', marginTop: 16 }}>
                {canEditShifts && (
                <button
                    type="submit"
                    className="shift-form-button save-button"
                    disabled={buttonLoading}
                    style={{ position: 'relative', width: '120px', height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: buttonLoading ? .6 : 1, fontWeight: 700, letterSpacing: '.2px', borderRadius: 10 }}
                >
                    {buttonLoading ? (
                    <svg style={{ width: 20, height: 20, animation: 'rotate 1s linear infinite', position: 'absolute' }} viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" strokeWidth="4" stroke="white" strokeLinecap="round" strokeDasharray="90,150" strokeDashoffset="0" /></svg>
                    ) : (
                    <span className="button-label">{isEditing ? "Spara" : "Lägg till"}</span>
                    )}
                </button>
                )}

                <button type="button" onClick={() => handleCloseAttempt()} className="shift-form-button cancel-button" style={{ height: 40, padding: '0 16px', borderRadius: 10, fontWeight: 600 }}>Avbryt</button>

                {isEditing && canEditShifts && (
                <button
                    type="button"
                    onClick={deleteLoading ? undefined : handleShiftDelete}
                    className="shift-form-button delete-button"
                    disabled={deleteLoading || buttonLoading}
                    style={{ backgroundColor: '#dc3545', color: '#fff', position: 'relative', width: 110, height: 40, opacity: deleteLoading ? 0.7 : 1, cursor: deleteLoading ? 'not-allowed' : 'pointer', borderRadius: 10, fontWeight: 700 }}
                >
                    {deleteLoading ? (
                    <svg style={{ width: 20, height: 20, animation: 'rotate 1s linear infinite', position: 'absolute' }} viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" strokeWidth="4" stroke="white" strokeLinecap="round" strokeDasharray="90,150" strokeDashoffset="0" /></svg>
                    ) : (
                    <span className="button-label">Radera</span>
                    )}
                </button>
                )}
            </div>

            {/* Popups */}
            {showOvertimeForShiftPopup && (
                <OvertimeForShiftPopup
                employee={allEmployees.find(e => e._id === selectedEmployeeForOvertime)}
                overtimeRules={allOvertimeRules}
                initialOvertime={shiftFormData.employees.find(emp => emp.employeeId === selectedEmployeeForOvertime)?.overtime[selectedOvertimeIndex] || null}
                editIndex={selectedOvertimeIndex}
                onAdd={(ot, index) => {
                    const updatedEmployees = [...shiftFormData.employees];
                    const empIndex = updatedEmployees.findIndex(e => e.employeeId === selectedEmployeeForOvertime);
                    if (empIndex === -1) return;
                    if (!updatedEmployees[empIndex].overtime) { updatedEmployees[empIndex].overtime = []; }
                    if (typeof index === "number") { updatedEmployees[empIndex].overtime[index] = ot; } else { updatedEmployees[empIndex].overtime.push(ot); }
                    setShiftFormData({ ...shiftFormData, employees: updatedEmployees });
                }}
                onClose={() => { setShowOverTimeForShiftPopup(false); setSelectedOvertimeIndex(null); }}
                />
            )}

            

            {showAbsenceForShiftPopup && (
                <AbsenceForShiftPopup
                employee={allEmployees.find(e => e._id === selectedEmployeeForAbsence)}
                absenceRules={allAbsenceRules}
                initialAbsence={shiftFormData.employees.find(emp => emp.employeeId === selectedEmployeeForAbsence)?.absences?.[selectedAbsenceIndex] || null}
                editIndex={selectedAbsenceIndex}

                employeeDayShifts={(allShiftsToday || []).filter(shift =>
                  shift.employees?.some(emp => emp.employeeId === selectedEmployeeForAbsence)
                )}
                currentShiftId={currentShiftId}

                onAdd={(absence, index) => {
                    if (typeof index === "number") {
                    const updatedEmployees = [...shiftFormData.employees];
                    const empIndex = updatedEmployees.findIndex(e => e.employeeId === selectedEmployeeForAbsence);
                    if (empIndex !== -1) { updatedEmployees[empIndex].absences[index] = absence; setShiftFormData({ ...shiftFormData, employees: updatedEmployees }); }
                    } else {
                    handleAddAbsenceToEmployee(selectedEmployeeForAbsence, absence);
                    }
                }}
                onClose={() => { setShowAbsenceForShiftPopup(false); setSelectedAbsenceIndex(null); }}
                />
            )}

            {showBreakPopup && (
                <BreakForShiftPopup
                employee={allEmployees.find(e => e._id === selectedEmployeeForBreak)}
                initialBreak={shiftFormData.employees.find(emp => emp.employeeId === selectedEmployeeForBreak)?.breaks?.[selectedBreakIndex] || null}
                editIndex={selectedBreakIndex}
                onSave={(updatedBreak, index) => {
                    const updatedEmployees = [...shiftFormData.employees];
                    const empIndex = updatedEmployees.findIndex(e => e.employeeId === selectedEmployeeForBreak);
                    if (empIndex === -1) return;
                    if (!updatedEmployees[empIndex].breaks) { updatedEmployees[empIndex].breaks = []; }
                    if (typeof index === "number") { updatedEmployees[empIndex].breaks[index] = updatedBreak; } else { updatedEmployees[empIndex].breaks.push(updatedBreak); }
                    setShiftFormData({ ...shiftFormData, employees: updatedEmployees });
                }}
                onClose={() => { setShowBreakPopup(false); setSelectedBreakIndex(null); }}
                />
            )}

            {showMultipleDatesShiftPopup && (
                <MultipleDatesInShiftPopup
                initialStartDate={selectedMultipleStartDate}
                initialEndDate={selectedMultipleEndDate}
                initialMode={selectedMultipleMode}
                initialWeekdays={selectedMultipleWeekdays}
                initialCustomDates={selectedMultipleCustomDates}
                onClose={() => setShowMultipleDatesShiftPopup(false)}
                onConfirm={({ dates, startDate, endDate, mode, weekdays, customDates }) => {
                    setMultipleDates(dates);
                    setSelectedMultipleStartDate(startDate);
                    setSelectedMultipleEndDate(endDate);
                    setSelectedMultipleMode(mode);
                    setSelectedMultipleWeekdays(weekdays);
                    setSelectedMultipleCustomDates(customDates);
                    setShowMultipleDatesShiftPopup(false);
                }}
                />
            )}
            </form>

            {overlappingShiftWarningText !== "" && (
            <div style={{ marginTop: '12px', fontSize: '0.85rem', color: '#B91CC', textAlign: 'left', borderRadius: '10px', padding: '10px 12px', backgroundColor: '#FEE2E2', border: '1px solid #fecaca', boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}>
                <p style={{ fontWeight: 700, margin: 0 }}>{overlappingShiftWarningText}</p>
            </div>
            )}

            {employeesNotInProject.length > 0 && shiftFormData.project && !company?.autoProjectAssignment?.enabled && (
            <div style={{ marginTop: '12px', fontSize: '0.85rem', color: '#065f46', textAlign: 'left', borderRadius: '10px', padding: '10px 12px', background: '#ecfdf5', border: '1px solid#a7f3d0', boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}>
                {employeesNotInProject.map(emp => emp.name).join(', ')} – är inte tillagd{employeesNotInProject.length > 1 ? "a" : ""} i projektet <strong>{allProjects.find(p => p._id === shiftFormData.project)?.name || "Okänt projekt"}</strong> och kan därmed inte se sina pass vid projektet.
                <button onClick={handleAddEmployeesToProject} style={{ marginLeft: '8px', padding: '6px 12px', background: '#10B981', color: 'white', border: '1px solid #10B981', borderRadius: '8px', fontSize: '0.85rem', cursor: 'pointer' }}>Lägg till</button>
            </div>
            )}
        </div>
{showCloseWarning && (
  <div
    className="confirm-close-overlay"
    onClick={cancelClose}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.6)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10001,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: '#fff',
        borderRadius: 28,
        padding: 28,
        width: 480,
        maxWidth: '90%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
      }}
    >
      <div style={{ marginBottom: 20 }}>
        <h3
          style={{
            margin: 0,
            fontSize: '1.35rem',
            fontWeight: 600,
            color: '#0f172a',
          }}
        >
          Osparade ändringar
        </h3>
        <p
          style={{
            margin: '8px 0 0',
            fontSize: '0.9rem',
            color: '#475569',
            lineHeight: 1.5,
          }}
        >
          Du har gjort ändringar som inte har sparats.
          <br />
          Är du säker på att du vill stänga?
        </p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <button
          onClick={cancelClose}
          style={{
            padding: '10px 20px',
            borderRadius: 40,
            border: '1px solid #e2e8f0',
            background: '#ffffff',
            color: '#1e293b',
            fontWeight: 500,
            fontSize: '0.875rem',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = '#f8fafc')
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = '#ffffff')
          }
        >
          Avbryt
        </button>
        <button
          onClick={confirmClose}
          style={{
            padding: '10px 20px',
            borderRadius: 40,
            border: 'none',
            background: '#2563eb',
            color: '#fff',
            fontWeight: 500,
            fontSize: '0.875rem',
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(37,99,235,0.3)',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = '#1d4ed8')
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = '#2563eb')
          }
        >
          Stäng ändå
        </button>
      </div>
    </div>
  </div>
)}
        </div>
    );

};

export default ShiftEditorModal;